import { Input } from "../../components/ui/Input";
import { isHexColor } from "./color";

type ColorFieldProps = {
	label: string;
	/** For screen readers where the visible label repeats across groups; defaults to the label. */
	name?: string;
	value: string;
	onChange: (value: string) => void;
};

/**
 * A swatch for picking and a hex box for pasting a brand colour exactly.
 * Lower-cased as typed, because the server stores it that way and a pasted
 * `#C8102E` would otherwise never match what was saved.
 */
export const ColorField = ({ label, name = label, value, onChange }: ColorFieldProps) => {
	const valid = isHexColor(value);

	return (
		<div className="space-y-1.5">
			<span className="block text-sm text-ink">{label}</span>
			<span className="flex items-center gap-2">
				<input
					type="color"
					aria-label={`${name} colour`}
					className="h-9 w-10 shrink-0 cursor-pointer rounded-md border border-line bg-surface p-1"
					value={valid ? value : "#000000"}
					onChange={(event) => onChange(event.target.value.toLowerCase())}
				/>
				<Input
					aria-label={`${name} hex value`}
					value={value}
					maxLength={7}
					spellCheck={false}
					aria-invalid={!valid}
					className={valid ? "font-mono" : "border-alert-line font-mono"}
					onChange={(event) => {
						const typed = event.target.value.trim().toLowerCase();
						onChange(typed.startsWith("#") ? typed : `#${typed}`);
					}}
				/>
			</span>
		</div>
	);
};
